import React, { useState, useEffect } from 'react';
import './../css/BackToTopButton.css';

const BackToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Function to scroll to the top
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Function to check the scroll position and show/hide button
  const checkScrollPosition = () => {
    if (window.scrollY > 100) {
      setIsVisible(true);  // Show button when scrolled down more than 100px
    } else {
      setIsVisible(false); // Hide button when scrolled up
    }
  };

  // Add event listener to monitor scroll position
  useEffect(() => {
    window.addEventListener('scroll', checkScrollPosition);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('scroll', checkScrollPosition);
    };
  }, []);

  return (
    <div
      className={`back-to-top-btn ${isVisible ? 'visible' : ''}`}
      onClick={scrollToTop}
    >
      {/* <img alt="BackToTopButtonImg" src={BackToTopButtonImg} /> */}
      <i class="bi bi-arrow-up-short"></i>
    </div>
  );
};

export default BackToTopButton;
